import React, { useEffect, useState, Suspense } from "react";
import { SnackbarProvider } from "notistack";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import {
  createStyles,
  makeStyles,
  Theme,
  ThemeProvider,
  createMuiTheme,
  Container,
  Typography,
  Grid,
  Checkbox,
  CssBaseline,
  FormControlLabel,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import {
  formLogin,
  setUserSession,
  setRememberMe,
  getUserId,
  getPassword,
  getIsRememberMe,
  removeRememberMe,
} from "../../services/AuthenticationService";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LTLABS from "../../assets/images/LTLabs_logo.svg";
import { BASE_API_URL } from "../../configurations/constant";

let CancelToken: any = axios.CancelToken;
let cancel: any;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    SignIn: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(2),
      fontSize: "24px",
      fontWeight: 700,
      color: "#006597",
      textAlign: "center",
      fontFamily: "Roboto",
      opacity: 1,
      letterSpacing: "0px",
    },
    CompanyCode: {
      color: "#707070",
      fontSize: "20px",
      fontWeight: 300,
      // textAlign: "end",
      fontFamily: "Roboto",
    },
    desc1: {
      color: "#707070",
      fontSize: "20px",
      fontWeight: 300,
      paddingLeft: "2px",
      textAlign: "start",
      fontFamily: "Roboto",
      textTransform: "uppercase",
    },
    ForgotPass: {
      fontSize: "0.875rem",
      color: "#1E88E5",
      fontWeight: "bold",
      fontFamily: "Roboto",
    },
    Powered: {
      fontSize: 16,
      fontWeight: "bold",
      color: "#000000DE",
      paddingBottom: "1vh",
      fontFamily: "Roboto",
    },
    Paper: {
      margin: "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      width: "320px",
      height: "auto",
      alignContent: "center",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 14px #3540520D",
      opacity: 1,
      textAlign: "start",
      padding: 20,
      color: theme.palette.text.secondary,
    },
    RememberMe: {
      color: "#000000DE",
      fontSize: "14px",
      fontFamily: "Roboto",
      paddingTop: "10px",
    },
    submit: {
      margin: theme.spacing(2, 0, 2),
      height: "36px",
      fontSize: 16,
      background: "#1E88E5",
      color: "#FFFFFF",
      fontWeight: "normal",
      borderRadius: "4px",
      fontFamily: "Roboto",
      "&:hover": {
        background: "#1E88E5",
      },
    },
    LogoFooter: {
      position: "fixed",
      left: 0,
      bottom: 10,
    },
    PoweredLogo: {
      color: "#707070",
      fontSize: "12px",
      textAlign: "end",
      paddingRight: "5px",
      paddingBottom: "6px",
      fontFamily: "Roboto",
    },
    ErrorMessage: {
      color: "#f44336",
      fontFamily: "Roboto",
      fontSize: "14px",
      marginTop: "0",
    },
    asterisk: {
      color: "red"
    }
  })
);

const Form = () => {
  const classes = useStyles();
  const history = useHistory();
  // let local = window.location.href;
  // let comCode = local.split("/");
  // localStorage.setItem("companyCode", comCode);
  let comCode = localStorage.getItem("companyCode");
  localStorage.removeItem("token");

  const [code] = useState(comCode);
  const [title, setTitle] = useState("");
  const [messerror, setMesserror] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { handleSubmit, register, errors } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const [index, setIndex] = useState(0);
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (getIsRememberMe() === "true") {
      setUsername(`${getUserId()}`);
      setPassword(`${getPassword()}`);
      setChecked(true);
    }
    getDec(comCode);

    !getIsRememberMe() && localStorage.removeItem("userId");
    localStorage.removeItem("user");
    localStorage.removeItem("i18nextLng");
    localStorage.removeItem("user");
    localStorage.removeItem("ID");
    localStorage.removeItem("usernamedata");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("token");

    const timer = setInterval(() => setIndex((i) => i + 1), 600000); // 10 minutes
    return () => clearInterval(timer);
  }, []);


  const onSubmit = (data: any, event: any) => {
    event.preventDefault();
    let params = {
      companyCode: comCode,
      username: data.username,
      password: data.password,
      // desc1: data.desc1,
    };
    login(params);
  };

  const handleChange = (event: any) => {
    setChecked(event.target.checked);
  };

  const getDec = async (comCode: any) => {
    await axios
      .get(`${BASE_API_URL}company/${comCode}`)
      .then((res) => {
        const result = res.data;
        setTitle(result.desc1);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const login = async (params: any) => {
    setIsLoading(true);
    cancel && cancel();

    try {
      let asyncData = await formLogin(params, {
        cancelToken: new CancelToken(function executor(c: any) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
      });

      if (asyncData === undefined) {
        const message = "Intermittent or Disconnected Connection";
        setMesserror(message);
      } else {
        if (
          asyncData.status !== undefined &&
          asyncData.statusText !== undefined &&
          asyncData.status !== 200 &&
          asyncData.statusText !== "OK"
        ) {
          if (asyncData.data.errno) {
            const message = asyncData.data.message;
            setMesserror(message);
          } else {
            const message = asyncData.data.message;
            setMesserror(message);
          }
        } else {
          localStorage.setItem("ID", asyncData[0].data.userId);
          localStorage.setItem("token", asyncData[0].data.accessToken);
          localStorage.setItem("factoryId", asyncData[0].data.factoryId);
          localStorage.setItem("factory", asyncData[0].data.factory);
          localStorage.setItem("mfgline", asyncData[0].data.mfgLineId);

          if (asyncData[0].data["errorNo"]) {
            const message = asyncData[0].data["errorText"];
            setMesserror(message);
          } else {
            let userId = params.username;
            let fakeToken = (asyncData[0].data.accessToken).toString();
            let password = params.password;
            let companyCode = comCode;
            setUserSession(fakeToken, userId);

            if (checked === true) {
              setRememberMe(userId, password, companyCode, checked);
            } else {
              removeRememberMe();
            }


            if (asyncData[0].data.userId === 1 || asyncData[0].data.role === "Administrator" || asyncData[0].data.role === "admin") {
              history.push(`${companyCode}/admin/landingpage`);
            } else {
              const headers = {
                Authorization: asyncData[0].data.accessToken,
                ContentType: "application/json",
              };
              await axios
                .get(`${BASE_API_URL}userproduct`, { headers })
                .then((res) => {
                  console.log("--res.data--", res.data)
                  if (res.data.data.products.length < 1 || res.data.data.products.length == 0) {
                    setMesserror("This user has no access to this product!");
                  } else {
                    window.location.href = res.data.data.products[0].productURL;
                  }
                })
                .catch(function (error) {
                  console.log("--error--", error);
                  setMesserror("This user has no access to this product!");
                });

            }
          }
        }
      }
    } catch (error) {
      console.log("--error--", error);
      // Error
      if (error.response) {
        /*
         * The request was made and the server responded with a
         * status code that falls out of the range of 2xx
         */
        const message = error.response.data;
        setMesserror(message);
      } else if (error.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser and an instance
         * of http.ClientRequest in Node.js
         */
        const message = error.request;
        setMesserror(message);
      } else {
        // Something happened in setting up the request and triggered an Error
        const message = error.message;
        setMesserror(message);
      }

      if (axios.isCancel(error)) {
        throw new Error("Cancelled");
      }
    } finally {
      setIsLoading(false);
    }
  };

  let LoginLayout = createMuiTheme({
    breakpoints: {
      values: {
        xs: 800,
        sm: 1024,
        md: 1280,
        lg: 1440,
        xl: 1920,
      },
    },
    overrides: {
      MuiFilledInput: {
        root: {
          backgroundColor: "#FFFFFF",
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          "&$checked": {
            color: "#1E88E5",
          },
        },
      },
    },
  });

  return (
    <Suspense fallback="Loading...">
      <div className="Wrapper">
        <Container component="main" maxWidth="xs">
          <ThemeProvider theme={LoginLayout}>
            <CssBaseline />
            <Grid container style={{ marginBottom: "8vh" }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography className={classes.SignIn}>
                  Sign in to {title}{" "}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} className={classes.CompanyCode}>
                Company Code: {code}
              </Grid>
            </Grid>
            <div className={classes.Paper}>
              <Typography className={classes.Powered}>
                Please enter your login Information
              </Typography>

              <form
                className={classes.form}
                onSubmit={handleSubmit(onSubmit)}
                autoComplete="off"
              >
                <p className={classes.ErrorMessage}> {messerror} </p>
                <TextField
                  variant="standard"
                  type="text"
                  required
                  fullWidth
                  name="username"
                  value={username}
                  label="User ID / Email Address"
                  onChange={(e) => setUsername(e.target.value)}
                  autoFocus={true}
                  error={messerror ? true : false}
                  inputRef={register({
                    maxLength: {
                      value: 50,
                      message: "Value exceed maximum length",
                    },
                  })}
                  InputLabelProps={{
                    classes: {
                      asterisk: classes.asterisk
                    }
                  }}
                />
                <br />
                {/* {errors.username && (
                  <span style={{ color: "red" }}>
                    {errors.username.message}
                  </span>
                )} */}
                <TextField
                  variant="standard"
                  type={showPassword ? "text" : "password"}
                  required
                  fullWidth
                  id="password"
                  name="password"
                  value={password}
                  label="Password"
                  margin="dense"
                  onChange={(e) => setPassword(e.target.value)}
                  error={messerror ? true : false}
                  inputRef={register({
                    maxLength: {
                      value: 50,
                      message: "Value exceed maximum length",
                    },
                  })}
                  InputLabelProps={{
                    classes: {
                      asterisk: classes.asterisk
                    }
                  }}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <br />
                {errors.password && (
                  <span style={{ color: "red" }}>
                    {errors.password.message}
                  </span>
                )}
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={checked}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "checkbox with black color" }}
                    />
                  }
                  className={classes.RememberMe}
                  label="Remember me"
                />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className={classes.submit}
                  disabled={isLoading}
                >
                  Sign In
                </Button>
              </form>
            </div>

            <Grid
              container
              direction="row"
              alignItems="center"
              justify="center"
              className={classes.LogoFooter}
            >
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Typography className={classes.PoweredLogo}>
                  Powered by
                </Typography>
                {/* {new Date().getFullYear()}
            {'.'} */}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Typography variant="body2" color="textSecondary" align="left">
                  <img
                    src={LTLABS}
                    alt="LTLABS"
                    style={{
                      color: "rgb(0,101,151)",
                      height: 24,
                      width: 62
                    }}
                  />
                </Typography>
              </Grid>
            </Grid>
          </ThemeProvider>
        </Container>
      </div>
    </Suspense>
  );
};

const Login = () => {
  return (
    <SnackbarProvider autoHideDuration={3000} maxSnack={2}>
      <Form />
    </SnackbarProvider>
  );
};

export default Login;
